import { call, put, takeLatest } from 'redux-saga/effects';
import { base_url, endpoints } from '../../../constants';
import { AxiosService } from '../../../services';
import { actionTypes } from '../../../types';
import {
    saveInfluencerProfileSuccess,
    saveInfluencerProfileFailure,
} from '../../actions/authActions/saveInfluencerProfileActions';

function* saveInfluencerProfile({ payload, callback }) {
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.saveInfluencerProfile,
            payload: payload,
            isAuth: true,
        });
        yield put(
            saveInfluencerProfileSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message,
            })
        );
        if (callback && response?.data?.status === 200) {
            callback(response.data.response, response?.data?.status);
        } else if (callback) {
            callback(response.data.message, response?.data?.status);
        }
    } catch (error) {
        console.log('SAVE_INFLUENCER_PROFILE_FAILURE:', error?.response?.data);
        yield put(
            saveInfluencerProfileFailure({
                status: error?.response?.data?.status,
                response: {},
                message: error?.response?.data?.message,
            })
        );
    }
}

function* saveInfluencerProfileSaga() {
    yield takeLatest(actionTypes.SAVE_INFLUENCER_PROFILE_REQUEST, saveInfluencerProfile);
}

export default saveInfluencerProfileSaga;
